import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-user-line',
      title: 'Men Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/ministries/men'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Women Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/ministries/women'
    },
    {
      icon: 'ri-football-line',
      title: 'Youth Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/ministries/youth'
    },
    {
      icon: 'ri-bear-smile-line',
      title: 'Children Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/ministries/children'
    },
    {
      icon: 'ri-global-line',
      title: 'Evangelism Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/ministries/evangelism'
    },
    {
      icon: 'ri-music-line',
      title: 'Choir Ministry',
      description: 'Sundays at the Kings Centre',
      path: '/'
    },
  ];

  const handleServiceClick = (path: string) => {
    if (path === '/') {
      const element = document.getElementById('ministries');
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate(path);
    }
  };

  return (
    <section id="ministries" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-black mb-4">Our Ministries</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Join us in one of our vibrant ministries and be part of a community that serves God and impacts lives.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              onClick={() => handleServiceClick(service.path)}
              className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-gray-200"
            >
              <div className="w-14 h-14 bg-black rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
